"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MsgSetFlatFeeResponse = exports.MsgSetFlatFee = exports.MsgWithdrawRewardsResponse = exports.MsgWithdrawRewards_RecordIDs = exports.MsgWithdrawRewards_RecordsLimit = exports.MsgWithdrawRewards = exports.MsgSetContractMetadataResponse = exports.MsgSetContractMetadata = void 0;
/* eslint-disable */
const rewards_1 = require("./rewards");
const coin_1 = require("../../../cosmos/base/v1beta1/coin");
const helpers_1 = require("../../../helpers");
const _m0 = __importStar(require("protobufjs/minimal"));
function createBaseMsgSetContractMetadata() {
    return {
        senderAddress: "",
        metadata: undefined
    };
}
exports.MsgSetContractMetadata = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.senderAddress !== "") {
            writer.uint32(10).string(message.senderAddress);
        }
        if (message.metadata !== undefined) {
            rewards_1.ContractMetadata.encode(message.metadata, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgSetContractMetadata();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.senderAddress = reader.string();
                    break;
                case 2:
                    message.metadata = rewards_1.ContractMetadata.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            senderAddress: (0, helpers_1.isSet)(object.senderAddress) ? String(object.senderAddress) : "",
            metadata: (0, helpers_1.isSet)(object.metadata) ? rewards_1.ContractMetadata.fromJSON(object.metadata) : undefined
        };
    },
    toJSON(message) {
        const obj = {};
        message.senderAddress !== undefined && (obj.senderAddress = message.senderAddress);
        message.metadata !== undefined && (obj.metadata = message.metadata ? rewards_1.ContractMetadata.toJSON(message.metadata) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseMsgSetContractMetadata();
        message.senderAddress = (_a = object.senderAddress) !== null && _a !== void 0 ? _a : "";
        message.metadata = object.metadata !== undefined && object.metadata !== null ? rewards_1.ContractMetadata.fromPartial(object.metadata) : undefined;
        return message;
    }
};
function createBaseMsgSetContractMetadataResponse() {
    return {};
}
exports.MsgSetContractMetadataResponse = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgSetContractMetadataResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgSetContractMetadataResponse();
        return message;
    }
};
function createBaseMsgWithdrawRewards() {
    return {
        rewardsAddress: "",
        recordsLimit: undefined,
        recordIds: undefined
    };
}
exports.MsgWithdrawRewards = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.rewardsAddress !== "") {
            writer.uint32(10).string(message.rewardsAddress);
        }
        if (message.recordsLimit !== undefined) {
            exports.MsgWithdrawRewards_RecordsLimit.encode(message.recordsLimit, writer.uint32(18).fork()).ldelim();
        }
        if (message.recordIds !== undefined) {
            exports.MsgWithdrawRewards_RecordIDs.encode(message.recordIds, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgWithdrawRewards();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.rewardsAddress = reader.string();
                    break;
                case 2:
                    message.recordsLimit = exports.MsgWithdrawRewards_RecordsLimit.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.recordIds = exports.MsgWithdrawRewards_RecordIDs.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            rewardsAddress: (0, helpers_1.isSet)(object.rewardsAddress) ? String(object.rewardsAddress) : "",
            recordsLimit: (0, helpers_1.isSet)(object.recordsLimit) ? exports.MsgWithdrawRewards_RecordsLimit.fromJSON(object.recordsLimit) : undefined,
            recordIds: (0, helpers_1.isSet)(object.recordIds) ? exports.MsgWithdrawRewards_RecordIDs.fromJSON(object.recordIds) : undefined
        };
    },
    toJSON(message) {
        const obj = {};
        message.rewardsAddress !== undefined && (obj.rewardsAddress = message.rewardsAddress);
        message.recordsLimit !== undefined && (obj.recordsLimit = message.recordsLimit ? exports.MsgWithdrawRewards_RecordsLimit.toJSON(message.recordsLimit) : undefined);
        message.recordIds !== undefined && (obj.recordIds = message.recordIds ? exports.MsgWithdrawRewards_RecordIDs.toJSON(message.recordIds) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseMsgWithdrawRewards();
        message.rewardsAddress = (_a = object.rewardsAddress) !== null && _a !== void 0 ? _a : "";
        message.recordsLimit = object.recordsLimit !== undefined && object.recordsLimit !== null ? exports.MsgWithdrawRewards_RecordsLimit.fromPartial(object.recordsLimit) : undefined;
        message.recordIds = object.recordIds !== undefined && object.recordIds !== null ? exports.MsgWithdrawRewards_RecordIDs.fromPartial(object.recordIds) : undefined;
        return message;
    }
};
function createBaseMsgWithdrawRewards_RecordsLimit() {
    return {
        limit: helpers_1.Long.UZERO
    };
}
exports.MsgWithdrawRewards_RecordsLimit = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.limit.isZero()) {
            writer.uint32(8).uint64(message.limit);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgWithdrawRewards_RecordsLimit();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.limit = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            limit: (0, helpers_1.isSet)(object.limit) ? helpers_1.Long.fromValue(object.limit) : helpers_1.Long.UZERO
        };
    },
    toJSON(message) {
        const obj = {};
        message.limit !== undefined && (obj.limit = (message.limit || helpers_1.Long.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseMsgWithdrawRewards_RecordsLimit();
        message.limit = object.limit !== undefined && object.limit !== null ? helpers_1.Long.fromValue(object.limit) : helpers_1.Long.UZERO;
        return message;
    }
};
function createBaseMsgWithdrawRewards_RecordIDs() {
    return {
        ids: []
    };
}
exports.MsgWithdrawRewards_RecordIDs = {
    encode(message, writer = _m0.Writer.create()) {
        writer.uint32(10).fork();
        for (const v of message.ids) {
            writer.uint64(v);
        }
        writer.ldelim();
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgWithdrawRewards_RecordIDs();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.ids.push(reader.uint64());
                        }
                    }
                    else {
                        message.ids.push(reader.uint64());
                    }
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            ids: Array.isArray(object === null || object === void 0 ? void 0 : object.ids) ? object.ids.map((e) => helpers_1.Long.fromValue(e)) : []
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.ids) {
            obj.ids = message.ids.map(e => (e || helpers_1.Long.UZERO).toString());
        }
        else {
            obj.ids = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseMsgWithdrawRewards_RecordIDs();
        message.ids = ((_a = object.ids) === null || _a === void 0 ? void 0 : _a.map(e => helpers_1.Long.fromValue(e))) || [];
        return message;
    }
};
function createBaseMsgWithdrawRewardsResponse() {
    return {
        recordsNum: helpers_1.Long.UZERO,
        totalRewards: []
    };
}
exports.MsgWithdrawRewardsResponse = {
    encode(message, writer = _m0.Writer.create()) {
        if (!message.recordsNum.isZero()) {
            writer.uint32(8).uint64(message.recordsNum);
        }
        for (const v of message.totalRewards) {
            coin_1.Coin.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgWithdrawRewardsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.recordsNum = reader.uint64();
                    break;
                case 2:
                    message.totalRewards.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            recordsNum: (0, helpers_1.isSet)(object.recordsNum) ? helpers_1.Long.fromValue(object.recordsNum) : helpers_1.Long.UZERO,
            totalRewards: Array.isArray(object === null || object === void 0 ? void 0 : object.totalRewards) ? object.totalRewards.map((e) => coin_1.Coin.fromJSON(e)) : []
        };
    },
    toJSON(message) {
        const obj = {};
        message.recordsNum !== undefined && (obj.recordsNum = (message.recordsNum || helpers_1.Long.UZERO).toString());
        if (message.totalRewards) {
            obj.totalRewards = message.totalRewards.map(e => e ? coin_1.Coin.toJSON(e) : undefined);
        }
        else {
            obj.totalRewards = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = createBaseMsgWithdrawRewardsResponse();
        message.recordsNum = object.recordsNum !== undefined && object.recordsNum !== null ? helpers_1.Long.fromValue(object.recordsNum) : helpers_1.Long.UZERO;
        message.totalRewards = ((_a = object.totalRewards) === null || _a === void 0 ? void 0 : _a.map(e => coin_1.Coin.fromPartial(e))) || [];
        return message;
    }
};
function createBaseMsgSetFlatFee() {
    return {
        senderAddress: "",
        contractAddress: "",
        flatFeeAmount: undefined
    };
}
exports.MsgSetFlatFee = {
    encode(message, writer = _m0.Writer.create()) {
        if (message.senderAddress !== "") {
            writer.uint32(10).string(message.senderAddress);
        }
        if (message.contractAddress !== "") {
            writer.uint32(18).string(message.contractAddress);
        }
        if (message.flatFeeAmount !== undefined) {
            coin_1.Coin.encode(message.flatFeeAmount, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgSetFlatFee();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.senderAddress = reader.string();
                    break;
                case 2:
                    message.contractAddress = reader.string();
                    break;
                case 3:
                    message.flatFeeAmount = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        return {
            senderAddress: (0, helpers_1.isSet)(object.senderAddress) ? String(object.senderAddress) : "",
            contractAddress: (0, helpers_1.isSet)(object.contractAddress) ? String(object.contractAddress) : "",
            flatFeeAmount: (0, helpers_1.isSet)(object.flatFeeAmount) ? coin_1.Coin.fromJSON(object.flatFeeAmount) : undefined
        };
    },
    toJSON(message) {
        const obj = {};
        message.senderAddress !== undefined && (obj.senderAddress = message.senderAddress);
        message.contractAddress !== undefined && (obj.contractAddress = message.contractAddress);
        message.flatFeeAmount !== undefined && (obj.flatFeeAmount = message.flatFeeAmount ? coin_1.Coin.toJSON(message.flatFeeAmount) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseMsgSetFlatFee();
        message.senderAddress = (_a = object.senderAddress) !== null && _a !== void 0 ? _a : "";
        message.contractAddress = (_b = object.contractAddress) !== null && _b !== void 0 ? _b : "";
        message.flatFeeAmount = object.flatFeeAmount !== undefined && object.flatFeeAmount !== null ? coin_1.Coin.fromPartial(object.flatFeeAmount) : undefined;
        return message;
    }
};
function createBaseMsgSetFlatFeeResponse() {
    return {};
}
exports.MsgSetFlatFeeResponse = {
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgSetFlatFeeResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseMsgSetFlatFeeResponse();
        return message;
    }
};
//# sourceMappingURL=tx.js.map